import { Component, ComponentFactoryResolver, OnInit, ViewContainerRef } from '@angular/core';
import {  ViewChild, ViewEncapsulation } from "@angular/core";
import { ActivatedRoute, Router } from '@angular/router';
import { NgbModal, NgbModalOptions } from '@ng-bootstrap/ng-bootstrap';
import { DatatableComponent, ColumnMode } from "@swimlane/ngx-datatable";
import { ApiService } from 'app/shared/services/api.service';
import { environment } from 'environments/environment';
import { NgxSpinnerService } from 'ngx-spinner';
import { ToastrService } from 'ngx-toastr';
import swal from 'sweetalert2';
import { DynamicDetailComponent } from '../../dynamic-detail/dynamic-detail.component';
import { Store } from '@ngrx/store';
import { AppState } from 'app/App Store/state';
import { Subscription } from 'rxjs';
import { setPageNumber } from 'app/App Store/actions/pageChange.actions';


@Component({
  selector: 'app-batch-list',
  templateUrl: './batch-list.component.html',
  styleUrls: ['./batch-list.component.scss' , "../../../../../../assets/sass/libs/datatables.scss"],
  encapsulation: ViewEncapsulation.None,

})
export class BatchListComponent implements OnInit {
 
    @ViewChild(DatatableComponent) table: DatatableComponent;
    page = {
      pageNumber:0,
      offset: 0,
      pageSize: 100,
      totalPages:0
    };
    // row data
    public rows = [];
    public filterRows=[];
    public ColumnMode = ColumnMode;
    public limitRef = 100;
    selectedValue=''
    isFilter:boolean=false
    public columns = [
      { name: "Batch Name", prop: "name" },
      { name: "Batch Type", prop: "batchType" },
      {name:"Duration",prop:"duration"},
      { name: "Number of Seats", prop: "noOfSeats" },
      { name: "Start Time", prop: "startTime" },
      { name: "Status", prop: "status" },


    ];
  
    // private
    private tempData = []; 
  
    imageUrl = environment.apiUrls.imageUrl;
    batch_id:any;
    user_role:any
    statusList = []
    activeTab =''
    emp_type_eng:any
    emp_type_Hr:any
    emp_type_mng:any

    instructor_id:any
    isInstructor : boolean = false

    guideline_data:any
    empType =[]

    constructor( public apiService:ApiService,
                 private modalService: NgbModal,
                 public toastr: ToastrService,private activerouter: ActivatedRoute,
                 private route: Router, private spinner: NgxSpinnerService,private resolver: ComponentFactoryResolver,) { 
                  this.user_role=JSON.parse(localStorage.getItem('user'))
                  if(this.user_role.roles !=='admin'){
                    this.empType = this.user_role.employeetype.filter(item => item.displayname)
                  }
                 
                  let setting_data = JSON.parse(localStorage.getItem('setting-record'))
                  let key_data = setting_data.filter((item) => item.key === 'Batch') 
                  this.guideline_data = key_data[0]?._id
                  this.getBatchStatusList()

                  
          
                  } 
  
    ngOnInit() {
      if(this.user_role.roles ==='admin' || !this.empType.includes('Teacher')){
        this.activeBatchTab('current')
      }
      if(this.empType.includes('Teacher')){
        this.emp_type_eng = this.user_role.employeetype.filter(type => type === '6344009391f6bc691e775fff');
             
        if(this.emp_type_eng !== ''  ){
          this.isInstructor = true
          this.getBatchByIntstructor(this.user_role?.id)
        }
        if(this.emp_type_eng === '[]'  ) {
          this.activeBatchTab('current')

        }
    }
  }
 
    getBatchByIntstructor(id){
      this.isInstructor = true
      this.apiService.getBatchListByInstructor(id).subscribe((res:any)=>{
        this.rows=res?.data?.items
        this.page.totalPages=res?.data?.totalCount

      })
    }
    activeBatchTab(tab) {
      const activetab = tab;
      this.activeTab = tab
      if (activetab !== '') {
        this.route.navigate(
          [],
          { relativeTo: this.activerouter, queryParams: { status: activetab } }
        );
      }
    }
    setAndGetBatchbyStatus() {
      this.activerouter.queryParams
        .subscribe((params: any) => {
          this.activeTab = params?.status;
            this.getAllBatch()
        })
    }

    getBatchStatusList(){
      this.apiService.getLeadsStatusList("batchstatus").subscribe((res: any) => {
        this.statusList = res?.data
        this.setAndGetBatchbyStatus()
      })
    }
   
    getAllBatch(){
      this.spinner.show(undefined,
        {
          type: 'ball-triangle-path',
          size: 'medium',
          bdColor: 'rgba(0, 0, 0, 0.8)',
          color: '#fff',
          fullScreen: true
        });
        let status = this.statusList.find((item) => item.name == this.activeTab);
      this.apiService.getBatchListByStatus(status._id).subscribe((res:any)=>{
        this.rows=res?.data?.items
        this.page.totalPages=res?.data?.totalCount
      })
    }
    pageChangeData(page:any){
      // this.apiService.getBatchListByStatus(page.offset +1,page.pageSize).subscribe((res:any)=>{
      //   this.rows=res.data.items
      //   this.page.totalPages=res.data.totalCount
    
      // })
    }
    resetFilter(){
      this.setAndGetBatchbyStatus()
    }
    editTag(id:any){
    }
    batchDelete(password){
      if(this.batch_id){
        this.apiService.deleteBatch(this.batch_id,password).subscribe((res:any)=>{
          if(res.statusCode === 200){
            this.setAndGetBatchbyStatus()
          }
          else{
            this.toastr.error(res.error)
          } 
          })
      }
      else{
        this.toastr.error('something went wrong !!')
      }
    }
     // ================== Delete Alert ========================
     confirmDelete(id: any) {
      this.batch_id = id
      swal.fire({
        text: "Please Enter Password",
        input: 'password',
        showCancelButton: true,
      }).then((result) => {
        if (result.value) {
          this.batchDelete(result.value)
  
        } else if (result.dismiss === swal.DismissReason.cancel) {
          swal.fire({
            title: 'Cancelled',
            text: 'Your file is safe :)',
            icon: 'error',
            customClass: {
              confirmButton: 'btn btn-success'
            },
          })
        }
      });
    }
   
    updateBatchStatus(id, status_id){

      let body={
        status:status_id
      }
     if(id){
      this.apiService.updateBatch(id,body).subscribe((res:any)=>{
        if(res.statusCode === 200){
          this.toastr.success('Batch status update successfully')
          this.setAndGetBatchbyStatus()
        }
        else{
          this.toastr.error(res.error)
        }
      })
     }
    }
    openDynamicModal(key_id:string) {
      const modalOptions: NgbModalOptions = {
        size: 'lg', // 'sm', 'lg', or 'xl'
        backdrop: 'static',
      };
      const modalRef = this.modalService.open(DynamicDetailComponent,modalOptions);
      modalRef.componentInstance.key_id = key_id;
    }
  }
  